import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";
import { services } from "../data/mock";
import "../styles/Services.css";

const Services = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = ["All", "IV Infusions", "Botox & Anti-Wrinkle", "IM Injections", "Skin Boosters", "Facial Treatments"];

  const filteredServices = selectedCategory === "All"
    ? services
    : services.filter(service => service.category === selectedCategory);

  const handleBookNow = (serviceId) => {
    navigate(`/book?serviceId=${serviceId}`);
    window.scrollTo(0, 0);
  };

  return (
    <section id="services" className="services-section section-padding">
      <div className="container">
        <div className="services-header">
          <h2 className="hero-medium">Our Treatments</h2>
          <p className="body-large">
            Comprehensive aesthetic and wellness treatments tailored to your needs
          </p>
        </div>

        <div className="services-filter">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`filter-btn ${selectedCategory === category ? "active" : ""}`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="services-grid">
          {filteredServices.map((service) => (
            <div key={service.id} className="service-card hover-lift">
              <div className="service-header">
                <span className="service-category body-small">{service.category}</span>
                <span className="service-price heading-3">{service.price}</span>
              </div>
              <h3 className="heading-3 service-title">{service.title}</h3>
              <p className="body-regular service-description">{service.description}</p>
              <div className="service-footer">
                <span className="body-small">{service.duration}</span>
                <button 
                  onClick={() => handleBookNow(service.id)}
                  className="btn-book-now"
                >
                  <Calendar size={18} />
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
